import React, { Component, createContext } from "react";
import app from "../firebase";
export const DataBaseContext = createContext();

class DataBaseProvider extends Component {
  state = {
    user: false,
    uiState: "home",
    questions: [],
    studentname: "",
    studentemail: "",
    studentrollnum: "",
    studentData: [],
    instructions: [],
  };

  componentDidMount() {
    app.auth().onAuthStateChanged((user) => {
      user ? this.setState({ user: true }) : this.setState({ user: false });
    });
    app
      .firestore()
      .collection("questions")
      .get()
      .then((snapshot) => {
        snapshot.docs.forEach((doc) => {
          let question = {
            question: doc.data().question,
            answer: doc.data().answer,
            link: doc.data().link,
            id: doc.id,
          };
          this.setState({ questions: [...this.state.questions, question] });
        });
      });
    app
      .firestore()
      .collection("studentData")
      .get()
      .then((snapshot) => {
        snapshot.docs.forEach((doc) => {
          let studentData = {
            studentName: doc.data().studentName,
            studentEmail: doc.data().studentEmail,
            studentRollnum: doc.data().studentRollnum,
            studentMarks: doc.data().studentMarks,
            studenttime: doc.data().studenttime,
            id: doc.id,
          };
          this.setState({
            studentData: [...this.state.studentData, studentData],
          });
        });
      });
    app
      .firestore()
      .collection("instructions")
      .orderBy("sno", "asc")
      .get()
      .then((snapshot) => {
        snapshot.docs.forEach((doc) => {
          let instruction = {
            instruction: doc.data().instruction,
            sno: doc.data().sno,
            id: doc.id,
          };
          this.setState({
            instructions: [...this.state.instructions, instruction],
          });
        });
      });
  }

  loginUser = (email, password) => {
    app
      .auth()
      .signInWithEmailAndPassword(email, password)
      .then((e) => {
        console.log("logged in as ", e.user.email);
        this.setState({ user: true });
      })
      .catch((err) => {
        console.log(err);
        window.alert(err.message);
      });
  };

  updateViewController = (state) => {
    this.setState({ uiState: state });
  };
  addQuestion = (question) => {
    app
      .firestore()
      .collection("questions")
      .add({
        question: question.question,
        answer: question.answer,
        link: question.link,
      })
      .then((ref) => {
        let newquestion = { ...question, id: ref.id };
        this.setState({ questions: [...this.state.questions, newquestion] });
      });
  };

  removeQuestion = (id) => {
    let questions = this.state.questions.filter((e) => {
      return e.id !== id;
    });

    app
      .firestore()
      .collection("questions")
      .doc(id)
      .delete()
      .then((e) => {
        this.setState({ questions: questions });
      });
  };

  addStudentDetails = (name, rollnum, email) => {
    console.log(name, rollnum, email);
    this.setState({
      studentname: name,
      studentemail: email,
      studentrollnum: rollnum,
    });
  };

  updateStudentReview = (marks, endtime) => {
    console.log(endtime);

    app.firestore().collection("studentData").add({
      studentName: this.state.studentname,
      studentEmail: this.state.studentemail,
      studentRollnum: this.state.studentrollnum,
      studentMarks: marks,
      studenttime: endtime,
    });
  };
  deleteStudentsData = (id) => {
    let studentData = this.state.studentData.filter((e) => {
      return e.id !== id;
    });

    app
      .firestore()
      .collection("studentData")
      .doc(id)
      .delete()
      .then((e) => {
        this.setState({ studentData: studentData });
      });
  };

  makeAdmin = (email, password) => {
    console.log(email, password);
    app
      .auth()
      .createUserWithEmailAndPassword(email, password)
      .catch((err) => console.log(err));
  };
  addInstructions = (sno, instruction) => {
    console.log(sno, instruction);
    app
      .firestore()
      .collection("instructions")
      .add({
        instruction: instruction,
        sno: sno,
      })
      .then((ref) => {
        let newinstruction = { instruction, sno, id: ref.id };
        this.setState({
          instructions: [...this.state.instructions, newinstruction],
        });
      });
  };
  deleteInstruction = (id) => {
    let instructions = this.state.instructions.filter((e) => {
      return e.id !== id;
    });

    app
      .firestore()
      .collection("instructions")
      .doc(id)
      .delete()
      .then((e) => {
        this.setState({ instructions: instructions });
      });
  };
  render() {
    return (
      <DataBaseContext.Provider
        value={{
          ...this.state,
          user: this.state.user,
          loginUser: this.loginUser,
          uiState: this.state.uiState,
          updateViewController: this.updateViewController,
          questions: this.state.questions,
          addQuestion: this.addQuestion,
          removeQuestion: this.removeQuestion,
          addStudentDetails: this.addStudentDetails,
          studentname: this.state.studentname,
          updateStudentReview: this.updateStudentReview,
          studentData: this.state.studentData,
          deleteStudentsData: this.deleteStudentsData,
          makeAdmin: this.makeAdmin,
          addInstructions: this.addInstructions,
          instructions: this.state.instructions,
          deleteInstruction: this.deleteInstruction,
        }}
      >
        {this.props.children}
      </DataBaseContext.Provider>
    );
  }
}

export default DataBaseProvider;
